export function join (args) {
	return args
		.join('/')
		.replace(/\/+/g, '/')
		.replace(/\/$/, '')
		.replace(/^(.+):\//, '$1://')
		.replace(/^file:/, 'file:/')
		.replace(/\/(\?|&|#[^!])/g, '$1')
		.replace(/\?/g, '&')
		.replace('&', '?')
	;
};
